import { render, staticRenderFns } from "./CliniciansList.vue?vue&type=template&id=974a6170"
import script from "./CliniciansList.vue?vue&type=script&lang=js"
export * from "./CliniciansList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports